import { createSlice } from "@reduxjs/toolkit";
import { THEMES } from "src/constants";

var bg = window["configSite"]?.siteBg || "/static/images/bg.jpg";

const initialState = {
  direction: "ltr",
  responsiveFontSizes: true,
  settingsLoaded: false,
  theme: THEMES.LIGHT,
  adminMode: false,
  adminModeFor: null,
  siteConfigLoaded: false,
  siteConfig: null,
  isLoading: false,
  loadingCounter: 0,
  loadingStartTime: null,
  loadingMessage: "Cargando...",
  loadingMessageQueue: [],
  hideNavbar: false,
  groupStatColors: {},
  statsDefaults: {
    dateRange: "last_year",
  },
  csrf: null,
  open: false,
  config: {
    updated: null,
    modules: null,
    maintenance: false,
    login_bg: bg,
  },
  sections: [
    {
      subheader: "Reports",
      items: [
        {
          title: "Inicio",
          icon: "home",
          //   icon: NAVICONS['home'],
          href: "/app/",
        },
      ],
    },
  ],
};
const slice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setSettings: (state, action) => {
      const { settings } = action.payload;
      Object.keys(settings).map((k) => {
        state[k] = settings[k];
      });
      state.settingsLoaded = true;
      state.open = false;
      localStorage.setItem("settings", JSON.stringify(state));
    },
    setOpen: (state, action) => {
      const { open } = action.payload;
      state.open = open;
    },
    setLoaded: (state, action) => {
      const { loaded } = action.payload;

      state.settingsLoaded = loaded;
    },
    setCsrf: (state, action) => {
      const { csrf } = action.payload;
      state.csrf = csrf;
    },
    setAdminModeFor: (state, action) => {
      state.adminModeFor = action.payload;
    },
    setAdminMode: (state, action) => {
      state.adminMode = action.payload;
    },
    startLoading: (state, action) => {
      const message = action.payload || "Cargando...";
      state.loadingCounter += 1;

      // Solo actualizar timestamp en el primer loading
      if (state.loadingCounter === 1) {
        state.loadingStartTime = Date.now();
        state.isLoading = true;
      }

      // Actualizar mensaje si es diferente
      if (message !== state.loadingMessage) {
        state.loadingMessage = message;
      }
    },
    stopLoading: (state) => {
      state.loadingCounter = Math.max(0, state.loadingCounter - 1);

      // Solo cerrar cuando el contador llegue a 0
      if (state.loadingCounter === 0) {
        state.isLoading = false;
        state.loadingStartTime = null;
      }
    },
    resetLoading: (state) => {
      state.loadingCounter = 0;
      state.isLoading = false;
      state.loadingStartTime = null;
    },
    setIsLoading: (state, action) => {
      // Mantener compatibilidad con código existente
      if (action.payload === true) {
        state.loadingCounter += 1;
        if (state.loadingCounter === 1) {
          state.loadingStartTime = Date.now();
        }
      } else {
        state.loadingCounter = Math.max(0, state.loadingCounter - 1);
      }
      state.isLoading = state.loadingCounter > 0;
    },
    setLoadingMessage: (state, action) => {
      state.loadingMessage = action.payload;
    },
  },
});

export const reducer = slice.reducer;

// Nueva API mejorada
export const startLoading =
  (message = "Cargando...") =>
  async (dispatch) => {
    dispatch(slice.actions.startLoading(message));
  };

export const stopLoading = () => async (dispatch, getState) => {
  const state = getState();
  const { loadingStartTime } = state.settings;

  // Garantizar tiempo mínimo de visualización (300ms)
  const MINIMUM_DISPLAY_TIME = 300;

  if (loadingStartTime) {
    const elapsed = Date.now() - loadingStartTime;
    const remaining = Math.max(0, MINIMUM_DISPLAY_TIME - elapsed);

    if (remaining > 0) {
      // Esperar el tiempo restante antes de cerrar
      await new Promise((resolve) => setTimeout(resolve, remaining));
    }
  }

  dispatch(slice.actions.stopLoading());
};

export const resetLoading = () => async (dispatch) => {
  dispatch(slice.actions.resetLoading());
};

// Mantener compatibilidad con API anterior
export const setIsLoading = (data) => async (dispatch) => {
  dispatch(slice.actions.setIsLoading(data));
};

export const setLoadingMessage = (data) => async (dispatch) => {
  dispatch(slice.actions.setLoadingMessage(data));
};
export const loadSiteConfig = () => async (dispatch) => {
  var _localConfig = localStorage.getItem("config");
  var defaultConfig = {
    version: 0,
  };
  if (_localConfig) {
    try {
      defaultConfig = JSON.parse(_localConfig);
    } catch (e) {
      console.log("error parsing local config", e);
      defaultConfig = {
        version: 0,
      };
    }
  }
  dispatch(
    slice.actions.setSettings({
      settings: {
        siteConfig: defaultConfig,
        siteConfigLoaded: true,
      },
    })
  );
};
export const loadSettings = () => async (dispatch) => {
  const settings = localStorage.getItem("settings");
  if (settings) {
    dispatch(slice.actions.setSettings({ settings: JSON.parse(settings) }));
    dispatch(slice.actions.setLoaded({ loaded: true, open: false }));
  } else {
    localStorage.setItem("settings", JSON.stringify(initialState));
    dispatch(slice.actions.setLoaded({ loaded: true, open: false }));
  }
};

export const saveSettings = (data) => async (dispatch) => {
  dispatch(slice.actions.setSettings({ settings: data }));
};

export const setOpen = (data) => async (dispatch) => {
  dispatch(slice.actions.setOpen({ open: data }));
};

export const setAdminModeFor = (data) => async (dispatch) => {
  const settings = localStorage.getItem("settings");
  var s = {};
  if (settings) {
    s = JSON.parse(settings);
    s.adminModeFor = data;
    dispatch(slice.actions.setAdminModeFor(data));
    localStorage.setItem("settings", JSON.stringify(s));
  } else {
    s = { adminModeFor: data };
    localStorage.setItem("settings", JSON.stringify(s));
  }
};
